import React from "react";
import { Typography } from "@material-ui/core";
import { CssTextField } from "./style";

export const LeagueRankForm = ({
	classes,
	userId,
	setUserId,
	newRank,
	setNewRank,
}) => {
	return (
		<>
			<Typography variant="h6" className={classes.sectionTitle}>
				Change League Rank
			</Typography>
			<div className={classes.inputRow}>
				<CssTextField
					className={classes.textField}
					label="User ID"
					variant="outlined"
					value={userId}
					onChange={(e) => setUserId(e.target.value)}
					required
				/>
				<CssTextField
					className={classes.textField}
					label="New Rank"
					variant="outlined"
					type="number"
					value={newRank}
					onChange={(e) => setNewRank(e.target.value)}
					error={newRank && parseInt(newRank) < 1}
					helperText={
						newRank && parseInt(newRank) < 1
							? "Rank must be a positive number"
							: ""
					}
					InputProps={{
						inputProps: { min: 1 },
					}}
					required
				/>
			</div>
		</>
	);
};

export const validateLeagueRankForm = (formData) => {
	const { userId, newRank } = formData;
	return userId && newRank && parseInt(newRank) > 0;
};
